const map = {
	"./logo-CSS.jpg": 55073,
	"./logo-Expo_Camera.jpg": 56026,
	"./logo-Express.jpg": 29928,
	"./logo-HTML.jpg": 89729,
	"./logo-JavaScript.jpg": 96871,
	"./logo-Node_JS.jpg": 46510,
	"./logo-PostgreSQL.jpg": 22592,
	"./logo-React.jpg": 81377,
	"./logo-React_Native.jpg": 56699,
	"./logo-SCSS.jpg": 75954,
	"./logo-Vue.jpg": 25740
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34922;